import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/** A yes/no before anything that stops an integration working. */
export const ConfirmDialog = ({ open, title, body, yes, onYes, onClose, testId }) => (
  <AlertDialog open={open} onOpenChange={(o) => !o && onClose()}>
    <AlertDialogContent data-testid={testId}>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{body}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={`${testId}-cancel`}>Keep it</AlertDialogCancel>
        <AlertDialogAction onClick={onYes} data-testid={`${testId}-yes`}>{yes}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const mono = { fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace", fontSize: 12.5 };

/** A dark code block with its own copy button. */
export const Code = ({ children, testId }) => {
  const copy = async () => {
    try { await navigator.clipboard.writeText(children); (await import("sonner")).toast.success("Copied"); }
    catch { /* the text is selectable */ }
  };
  return (
    <div style={{ position: "relative" }} data-testid={testId}>
      <pre style={{ ...mono, margin: 0, background: "#0B1220", color: "#E2E8F0", borderRadius: 12, padding: "16px 18px",
                    overflowX: "auto", lineHeight: 1.65, whiteSpace: "pre" }}>{children}</pre>
      <button type="button" onClick={copy} className="btn btn-ghost btn-sm" data-testid={testId ? `${testId}-copy` : undefined}
              style={{ position: "absolute", top: 10, right: 10, background: "rgba(255,255,255,.08)", color: "#fff", borderColor: "rgba(255,255,255,.18)" }}>
        Copy
      </button>
    </div>
  );
};
